import DatePicker from "@p-ban/common/src/components/form/DatePicker"

import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import useReceivableDates from "../../../../service/hooks/useReceivableDates"

import img from "./materialsArrivalDate.png"

const 部材到着予定日 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { includeDates, minDate, maxDate } = useReceivableDates()
  const { materialsArrivalDate: shouldShow } = getDisplayCondition(values)

  const onChange = (date: Date | null) => {
    if (date) {
      handlers.date({ name: FIELD_NAMES.部材到着予定日, value: date })
    }
  }

  return (
    <OneClickField isShow={shouldShow} legend="部材到着予定日" src={img}>
      <DatePicker
        selected={values.materialsArrivalDate}
        includeDates={includeDates}
        minDate={minDate}
        maxDate={maxDate}
        onChange={onChange}
      />
      <OneClickFieldMessages error={errors?.materialsArrivalDate} />
    </OneClickField>
  )
}

export default 部材到着予定日
